import Cookies from 'js-cookie'
import http from '@/api/Http'
import blob from '@/api/blob'

export default{
    async aes256(paramData, type){
        let param = {
            type: type,
            data: paramData
        }
        return http.post(`/api/access/aes256`,{param})
    },
    async login(providerId, userId,password, autoLogin, suId, sessionId, autoLoginCheck){
        let param = {
            providerId, userId,password, autoLogin, suId, sessionId
        }
        let retValue = http.post(`/api/access/login`,{param}).then((result) =>{
            var returnValue = {
                success: '',
                message: '',
                user :''
            }
            if(result.data){
                returnValue.success = result.data.success
                returnValue.message = result.data.message

                if(result.data.success === 'Y'){
                    let user ={
                        uuid: result.data.data.uuid,
                        birth: result.data.data.birth,
                        sexx: result.data.data.sexx,
                        suid: result.data.data.suid,
                        name: result.data.data.name,
                        idno: result.data.data.idno
                    }
                    returnValue.user = user
                    if (autoLoginCheck) {
                        Cookies.set('autoLogin', true, { expires: 50 })
                        Cookies.set('patientId',result.data.data.idno,{expires: 30})
                        Cookies.set('suid',result.data.data.suId,{expires: 30})
                        Cookies.set('sessionId',result.data.data.sessionId,{expires: 30})
                    } else {
                        Cookies.set('autoLogin', false, { expires: 50 })
                        Cookies.set('patientIdTemp',result.data.data.idno,{expires: 1/144})
                        Cookies.set('suidTemp',result.data.data.suId,{expires: 1/144})
                        Cookies.set('sessionIdTemp',result.data.data.sessionId,{expires: 1/144})                   
                    }
                    sessionStorage.setItem('suid', result.data.data.suId)
                    sessionStorage.setItem('sessionId', result.data.data.sessionId)
                }
            }
            return returnValue
        });
        return retValue
    },
    async signUp(providerId, userId, password, name, mobile, patientNumber, birth, gender, identityInfo, adultFlag, recommender){
        let param = {
            providerId, userId,password, name, mobile, patientNumber, birth, gender, identityInfo, adultFlag, recommender
        }
        return http.post(`/api/access/signUp`,{param})
    },
    async signOut(providerId, userId, password, uuid){
        let param = {
            providerId, userId,password, uuid
        }
        return http.post(`/api/access/signOut`,{param})
    },
    async changePassword(providerId, userId, password, newpassword, uuid){
        let param = {
            providerId, userId,password, newpassword, uuid
        }
        return http.post(`/api/access/changePassword`,{param})
    },
    async adminLogin(pvid, usid, pswd){
        return http.post(`/api/consumer/loginAdmin`,{ pvid, usid, pswd })
    },
    async sys0102a_a(pvid, idno){
        let param ={
            jobs: 'A',
            idno: idno
        }
        let request = {
            svrm: 'SYS0102A',
            pvid: pvid,
            param: param
        }
        return http.post(`/MediCare/agent/callNgtAgent`,request).then(r => r.data);
    },
    async findIdno(providerId, name, bith, mobile){
        let param = {
            providerId, name, bith, mobile
        }
        let retValue = http.post(`/api/access/findIdno`,{param}).then((result) =>{
            var returnValue = {
                success: '',
                message: '',
                user :''
            }
            if(result.data){
                returnValue.success = result.data.success
                returnValue.message = result.data.message

                if(result.data.success === 'Y'){
                    let user ={
                        uuid: result.data.data.uuid,
                        birth: result.data.data.birth,
                        sexx: result.data.data.sexx,
                        name: result.data.data.name,
                        idno: result.data.data.idno
                    }
                    returnValue.user = user

                }
            }
            return returnValue
        });
        return retValue
    },
    async findUserPswd(providerId, idno, name, bith, mobile){
        let param = {
            providerId, idno, name, bith, mobile
        }
        let retValue = http.post(`/api/access/findUserPswd`,{param}).then((result) =>{
            var returnValue = {
                success: '',
                message: '',
                user :''
            }
            if(result.data){
                returnValue.success = result.data.success
                returnValue.message = result.data.message

                if(result.data.success === 'Y'){
                    let user ={
                        uuid: result.data.data.uuid,
                        birth: result.data.data.birth,
                        sexx: result.data.data.sexx,
                        name: result.data.data.name,
                        idno: result.data.data.idno
                    }
                    returnValue.user = user

                }
            }
            return returnValue
        });
        return retValue
    },
    async resetPassword(uuid, newPassword){
    let param = {
        uuid, newPassword
    }
        return http.post(`/api/access/resetPassword`,{ param })
    },
    async getQrCode(path){
        return blob.post('/api/access/getQrCode', { path } )
    },
    async getCertMail(pvid, idno){
        let request = {
            pvid: pvid,
            idno: idno
        } 
        return await http.post(`/api/access/getCertMail`,request).then(r => r.data);
    },
    async changePasswordAdmin(providerId, password, newpassword){
        let param = {
            providerId, password, newpassword
        }
        return http.post(`/api/consumer/changePasswordAdmin`,{param})
    },
    async accessMenu(providerId, idno, menu){
        let request = {
            pvid: providerId,
            idno: idno,
            menu: menu
        } 
        return http.post(`/api/access/accessMenu`,{request})
    },
    async getDownLoad(idvalue, pvid, filename){
        return blob.get('/api/certificate/fileDownLoad',{ responseType: 'blob', params:{id:idvalue, pvid: pvid, filename:filename} })
    },
    async getFileList(providerId, path){
        let request = {
            pvid: providerId,
            dirPath: path
        } 
        return http.post(`/api/certificate/fileList`,{request})
    },
    async idlgInsert(sour, providerId, kind, name, bith){
        let request = {
            sour: sour,
            pvid: providerId,
            kind: kind,
            name: name,
            bith: bith
        } 
        return http.post(`/api/access/idlgInsert`,{request})
    },    
}
